














































































































































































































































import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class Features extends Vue {
    private size: string = "60px";
}
